import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { SelectListOption } from '@bmw-ds/components';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { IRoleBase } from '../../admin/countries/countries.models';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RoleOptionsService {
  private readonly http = inject(HttpClient);

  private readonly rolesUrl = `${environment.services.masterdata}/api/roles`;

  public getRoleOptions(): Observable<SelectListOption[]> {
    return this.http.get<IRoleBase[]>(this.rolesUrl).pipe(
      map((roles) => roles.map((role) => this.mapToOption(role))),
      map((options) =>
        [...options].sort((first, second) => first.id.localeCompare(second.id))
      ),
      shareReplay(1),
      catchError((error) => {
        console.error(
          'Error loading role options',
          error?.error?.message ?? 'Backend error message not available'
        );
        return of([]);
      })
    );
  }

  private mapToOption(role: IRoleBase): SelectListOption {
    return {
      id: role.id?.toString() ?? '0',
      label: role.name ?? '',
    };
  }
}
